import React from 'react';
import {
  LoadingOutlined
} from '@ant-design/icons';

import './style';

export default React.forwardRef((props, ref) => {
  const { style } = props;
  return (
    <div style={style} className="loadding-container">
      <LoadingOutlined style={{ fontSize: '3rem', color: '#1890ff' }} />
    </div>
  );
});
